module.exports = "/app/themes/skideal/dist/images/search-site-ski.svg?c72b07e944f88e12c7956ac337eda217";